// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__nWfXy","colCheckbox":"styles_colCheckbox__jNX44"};